import { LOCALES } from 'i18n/locales';

export const feedbackPromptIntl = {
    [LOCALES.ENGLISH]: {
        'feedbackPrompt.question': 'We value your input. Would you like to provide anonymous feedback to help us improve our service?'
    },
    [LOCALES.WELSH]: {
        'feedbackPrompt.question': 'Rydym yn gwerthfawrogi\'ch mewnbwn. Hoffech chi ddarparu adborth dienw i\'n helpu i wella\'n gwasanaeth?'
    }
};
